const ThemeHelpers = {
  initRequestAnimFrame: () => {
    window.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60)
        }
      )
    })()
  },
  runRequestAnimaion: fn => {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(fn)
    } else {
      if (window.requestAnimFrame == null) {
        ThemeHelpers.initRequestAnimFrame()
      }
      if (window.requestAnimFrame) {
        window.requestAnimFrame = fn
      }
    }
  },
  createCanvas: () => {
    var canvas = document.createElement("canvas")
    canvas.style.userSelect = "none"
    canvas.style.pointerEvents = "none"
    canvas.style.zIndex = 99999
    canvas.style.position = "fixed"
    canvas.style.left = canvas.style.top = "0"
    document.body.appendChild(canvas)
    return canvas
  },
}

export default ThemeHelpers
